<template>
    <footer class="border-t border-white/[0.06] py-10" role="contentinfo">
        <div class="flex flex-col gap-8 md:flex-row md:justify-between">
            <ul class="flex flex-wrap gap-x-8 gap-y-3 text-sm text-nomad-300">
                <li><a href="/pages/apps" target="_blank" class="hover:text-white">Download apps</a></li>
                <li><a href="https://forms.gle/JJXLnjQDuzdkYg5w8" target="_blank" class="hover:text-white">Upload music</a></li>
                <li><a href="https://status.nomadlyrics.com/" target="_blank" class="hover:text-white">Service status</a></li>
                <li><a href="/pages/privacy-policy" target="_blank" class="hover:text-white">Privacy policy</a></li>
                <li><a href="/pages/terms" target="_blank" class="hover:text-white">Terms of service</a></li>
            </ul>
        </div>
        <div class="mt-8 flex flex-col gap-2 text-xs text-nomad-500 sm:flex-row sm:justify-between">
            <p>&copy; {{ year }} Heesify</p>
            <a href="https://nexainteractives.com" target="_blank" class="hover:text-nomad-300">Built by Nexa Interactives</a>
        </div>
    </footer>
</template>
<script setup>
const year = new Date().getFullYear();
</script>
